module.exports = {
    title:"Book Recommendations",
    description: "Book Recommendations",
}